import { DatePlan, PreviousDate } from '../types';

const STORAGE_KEYS = {
  PREVIOUS_DATES: 'kolkata_date_planner:previous_dates',
  EXCLUDED_PLACES: 'kolkata_date_planner:excluded_places',
  SAVED_PLANS: 'kolkata_date_planner:saved_plans',
  PREFERENCES: 'kolkata_date_planner:preferences',
};

export class StorageService {
  static getPreviousDates(): PreviousDate[] {
    try {
      const data = localStorage.getItem(STORAGE_KEYS.PREVIOUS_DATES);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  }

  static addPreviousDate(date: PreviousDate): void {
    const dates = this.getPreviousDates();
    dates.unshift(date);
    localStorage.setItem(STORAGE_KEYS.PREVIOUS_DATES, JSON.stringify(dates.slice(0, 50))); // Keep last 50
  }

  static updatePreviousDate(id: string, updates: Partial<PreviousDate>): void {
    const dates = this.getPreviousDates();
    const index = dates.findIndex(d => d.id === id);
    if (index >= 0) {
      dates[index] = { ...dates[index], ...updates };
      localStorage.setItem(STORAGE_KEYS.PREVIOUS_DATES, JSON.stringify(dates));
    }
  }

  static getExcludedPlaces(): string[] {
    try {
      const data = localStorage.getItem(STORAGE_KEYS.EXCLUDED_PLACES);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  }

  static addExcludedPlace(placeId: string, placeName: string): void {
    const excluded = this.getExcludedPlaces();
    if (!excluded.includes(placeId)) {
      excluded.push(placeId);
      localStorage.setItem(STORAGE_KEYS.EXCLUDED_PLACES, JSON.stringify(excluded));
    }
  }

  static removeExcludedPlace(placeId: string): void {
    const excluded = this.getExcludedPlaces();
    const filtered = excluded.filter(id => id !== placeId);
    localStorage.setItem(STORAGE_KEYS.EXCLUDED_PLACES, JSON.stringify(filtered));
  }

  static getSavedPlans(): DatePlan[] {
    try {
      const data = localStorage.getItem(STORAGE_KEYS.SAVED_PLANS);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  }

  static savePlan(plan: DatePlan): void {
    const plans = this.getSavedPlans();
    const existing = plans.findIndex(p => p.id === plan.id);
    if (existing >= 0) {
      plans[existing] = plan;
    } else {
      plans.push(plan);
    }
    localStorage.setItem(STORAGE_KEYS.SAVED_PLANS, JSON.stringify(plans));
  }

  static removePlan(planId: string): void {
    const plans = this.getSavedPlans();
    const filtered = plans.filter(p => p.id !== planId);
    localStorage.setItem(STORAGE_KEYS.SAVED_PLANS, JSON.stringify(filtered));
  }

  static getPreferences(): Record<string, any> {
    try {
      const data = localStorage.getItem(STORAGE_KEYS.PREFERENCES);
      return data ? JSON.parse(data) : {};
    } catch {
      return {};
    }
  }

  static setPreferences(prefs: Record<string, any>): void {
    const current = this.getPreferences();
    localStorage.setItem(STORAGE_KEYS.PREFERENCES, JSON.stringify({ ...current, ...prefs }));
  }

  static clearAll(): void {
    Object.values(STORAGE_KEYS).forEach(key => localStorage.removeItem(key));
  }
}
